<template>
  <el-dialog
    title="批量下载"
    :visible="visible"
    width="850px"
    center
    custom-class="batch-download-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div v-loading="exporting" element-loading-text="查询中...">
      <section class="btns">
        <el-button type="primary" @click="handleExportMusicResult">查询录音结果</el-button>
        <el-button type="primary" @click="handleExportWorksResult">查询词曲结果</el-button>
        <el-button type="primary" @click="handleExportCompeteResult">查询竞品结果</el-button>
      </section>

      <p class="table-title">查询记录</p>
      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="流水ID" prop="id"></el-table-column>
        <el-table-column label="数据行数" prop="line"></el-table-column>
        <el-table-column label="模板类型" prop="downloadType" v-slot="{ row }">
          {{ row.downloadType ? '词曲' : '录音' }}
        </el-table-column>
        <el-table-column label="提交时间" prop="insertTime" width="200"></el-table-column>
        <el-table-column label="结果文件" prop="id" v-slot="{ row }">
          <a v-if="row.fileUrl" :href="row.fileUrl" target="_blank" download="导出结果">结果文件</a>
          <a v-else href="javascript:void(0)" @click="handleRefreshRecord(row)">
            <i class="el-icon-refresh" />
            刷新状态
          </a>
        </el-table-column>
        <el-table-column label="状态" prop="status" v-slot="{ row }">{{ statusMap[row.status] }}</el-table-column>
        <el-table-column label="失败原因" prop="reason"></el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-sizes="[20, 50, 100, 200, 5000]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>

      <div slot="footer" style="margin-top:30px;text-align:center">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'

import {
  TASK_TYPE_ENUM
} from '../const'

const statusMap = {
  0: '未处理',
  1: '查询中',
  2: '已完成',
  3: '已失败'
}

export default {
  name: 'BatchDownloadDialog',
  mixins: [paginationTableMixin],
  props: {
    visible: Boolean,
    mode: {
      type: Number,
      default: TASK_TYPE_ENUM.COMPLAINT
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      statusMap,

      exporting: false,
    }
  },
  watch: {
    visible() {
      this.visible && this.handleSearch()
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async fetchData(id) {
      this.loading = true
      try {
        const { list, total } = await complaintService.queryMatchDownloadRecords({
          id,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.tableData = list.map(item => {
          return {
            ...item,
            loading: false
          }
        })
        this.pagination.total = total
      } catch (error) {
        this.$alert(`查询导出记录失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    },
    async doExport(type = 0) {
      if (!this.params) {
        return this.$message.warning('请先选择筛选条件')
      }

      this.exporting = true
      try {
        await complaintService.exportMatchListAll({
          ...(this.params ?? {}),
          bussType: this.mode,
          downloadType: type
        })
        this.handleSearch()
      } catch (e) {
        this.$alert(`查询失败.${e.message}`, '错误', {
          type: 'error'
        })
      }
      this.exporting = false
    },
    handleExportMusicResult() {
      this.doExport(0) // 0 录音, 1 词曲, 2 竞品
    },
    handleExportWorksResult() {
      this.doExport(1)
    },
    handleExportCompeteResult() {
      this.doExport(2)
    },
    async handleRefreshRecord(row) {
      this.loading = true
      try {
        const { list } = await complaintService.queryMatchDownloadRecords({ id: row.id })
        if (list && list.length) {
          const newRow = list[0]
          const idx = this.tableData.findIndex(v => row.id === newRow.id)
          if (idx > -1) {
            this.tableData.splice(idx, 1, newRow)
          }
        }
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .batch-download-dialog {
  .table-title {
    margin: 15px 0 5px;
    font-weight: 600;
    font-size: 16px;
    color: #002444;
  }

  .el-dialog__header {
    border-bottom: 0;
  }

  .el-dialog__footer {
    border-top: 0;
  }
}
</style>
